import BatchScheduleSection from '@components/BatchScheduleSection'

const Batches = () => <div className="min-h-screen bg-gray-50 dark:bg-gray-950"><BatchScheduleSection /></div>

export default Batches
